import { ca } from '@cian/analytics';

export function trackShowAeroPhoto() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'CardJK',
    label: 'airphoto',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackClickAeroPhoto() {
  ca('eventSite', {
    action: 'show',
    category: 'CardJK',
    label: 'popup_airphoto',
    name: 'oldevent',
    useLastProducts: true,
  });
}
